import Vue from 'vue';
import getAuthenticatedUser, { logout } from '@/api/AuthenticatedUser';
import UserApi from '@/api/UserApi';
import { setLocale } from '@/i18n';

const userApi = new UserApi();

let userPromise = null;

const userModule = {
  state: {
    groups: [],
    user: null,
    name: '',
    locale: 'en-US',
  },

  getters: {
    groups: (state) => state.groups,
    name: (state) => state.name,
    user: (state) => state.user,
    users: (state) => state.users,
    avatar: (state) => state.avatar,
    locale: (state) => state.locale,
  },

  mutations: {
    SET_USER_INFO: (state, payload) => {
      state.groups = payload.groups || state.groups;
      state.user = payload || state.user;
      state.name = payload.name || state.name;
      state.locale = payload.languageId || state.locale;
    },
    SET_USER: (state, currentUser) => {
      state.user = currentUser;
    },
    SET_GROUPS: (state, groups) => {
      Vue.set(state, 'groups', groups);
    },
    SET_USERS: (state, users) => {
      Vue.set(state, 'users', users);
    },
    SET_LOCALE: (state, payload) => {
      state.locale = payload.locale;
    },
  },

  actions: {
    SetLocale: async (context, payload) => {
      context.commit('SET_LOCALE', payload);
      await setLocale(payload.locale, context.state.user.tenantId);
    },
    GetUserInfo: ({ commit, state, dispatch }) => {
      try {
        if (userPromise) {
          return userPromise;
        }

        userPromise = getAuthenticatedUser()
          .then((authenticatedUser) => {
            if (!state.user) {
              return userApi.getUser(authenticatedUser.signInUserSession.idToken.payload['cognito:username']);
            }
            return Promise.resolve(state.user);
          }, (err) => {
            console.warn('[vuex.user] GetUserInfo', err);
            commit('SET_USER_INFO', null);
            return Promise.reject();
          })
          .then((newUser) => {
            if (!state.user || newUser.id !== state.user.id) {
              // set new user state
              commit('SET_USER_INFO', newUser);
              const localePromise = dispatch('SetLocale', { locale: newUser.languageId });
              const routePromise = dispatch('GenerateRoutes', newUser, { root: true });
              return Promise.all([localePromise, routePromise]).then(() => newUser);
            }
            return Promise.resolve(newUser);
          }).finally(() => {
            userPromise = null;
          });
        return userPromise;
      } catch (err) {
        console.log(err);
        return Promise.resolve();
      }
    },
    SaveUser: async ({ commit }, user) => userApi.updateUser(user.id, user)
      .then(() => userApi.getUser(user.id))
      .then((newUser) => {
        commit('SET_USER_INFO', newUser);
        userPromise = null;
        return Promise.resolve(newUser);
      }, (err) => {
        console.warn('[vuex.user] GetUserInfo', err);
        userPromise = null;
        return Promise.resolve();
      }),

    LogOut: async ({ commit }, noRedirect) => {
      try {
        console.log('[vuex.user] LogOut');
        await logout();
        commit('SET_USER', {});
        if (!noRedirect) {
          window.location = './';
        }
      } catch (err) {
        console.warn('[vuex.user] LogOut', err);
      }
    },

  },
};

export default userModule;
